/**
 * Validates a PO Number based on various criteria
 * @param {boolean} isRequired - Whether the PO Number is required
 * @param {string} poNumber - The PO Number to validate
 * @param {object} localized - Localized error messages
 * @param {number} [maxLength] - Optional maximum length for the PO Number
 * @returns {object} Validation result with isValid and error properties
 */
export const validatePONumber = (
  isRequired,
  poNumber,
  localized = {},
  maxLength = undefined
) => {
  const fallbacks = {
    PORequiredMessage: "PO Number is required",
    POInvalidInput: "PO Number contains invalid characters",
    POMinLength: "PO Number must be at least 2 characters long",
    POMaxLength: "PO Number cannot exceed {maxLength} characters",
  };

  const trimmedPO = (poNumber ?? "").toString().trim();

  if (isRequired && trimmedPO === "") {
    return {
      isValid: false,
      error: localized.PORequiredMessage || fallbacks.PORequiredMessage,
    };
  }

  if (trimmedPO === "") {
    return { isValid: true, error: "" };
  }

  if (!/^[a-zA-Z0-9 '_\-\/\\.]+$/.test(trimmedPO)) {
    return {
      isValid: false,
      error: localized.POInvalidInput || fallbacks.POInvalidInput,
    };
  }

  if (trimmedPO.length < 2) {
    return {
      isValid: false,
      error: localized.POMinLength || fallbacks.POMinLength,
    };
  }

  if (maxLength && trimmedPO.length > maxLength) {
    return {
      isValid: false,
      error: (localized.POMaxLength || fallbacks.POMaxLength).replace(
        "{maxLength}",
        maxLength
      ),
    };
  }

  return { isValid: true, error: "" };
};
